/**
 * The ✕ at the top right of a sheet, drawn rather than typed.
 *
 * It was the character U+2715 until the polish pass of 2026-08-05, and it sat
 * a little low in its circle: measured in the browser, its ink centre fell
 * 0.78px below the centre of the 30px control. That is not a bug in the
 * padding. Centring a line box puts the baseline at `centre + (ascent -
 * descent) / 2` whatever the leading is, so where the ink lands after that
 * depends only on how tall the glyph happens to be — `line-height: 1` moves
 * it not at all, and a nudge tuned to one font stack is a nudge that is wrong
 * in the next one. Two lines in a viewBox are centred by construction.
 *
 * Sized to the glyph it replaces: ~10.3px across against the character's
 * 10.44px, so nothing else on the header row moves.
 */
export default function SheetClose({ onClose }) {
  return (
    <button type="button" className="sheet-close" onClick={onClose} aria-label="Close">
      <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <line
          x1="1.5"
          y1="1.5"
          x2="10.5"
          y2="10.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="10.5"
          y1="1.5"
          x2="1.5"
          y2="10.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  )
}
